import sum from 'lodash-es/sum';

const getUnfilterdTotal =
  <T>(data: T[], getValue: (input: T) => number): number =>
    sum(data.map(getValue));

export default getUnfilterdTotal;
